import { Button, DatePicker, Form, Input, Modal, Select } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { getAllMaster } from "../../../redux/rtk/features/masters/masterSlice";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import dayjs from "dayjs";
import { EmployeePaymentTypeHistorySetup } from "../../../redux/rtk/features/payment/paymentSlice";
import { loadSingleStaff } from "../../../redux/rtk/features/user/userSlice";
import { EmployeeLeavePolicyGroupHistorySetup } from "../../../redux/rtk/features/leavePolicy/leavePolicySlice";

// Employment Edit Single Popup
const LeavePolicyGroupEditSinglePopup = ({ data, setLoading }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [form] = Form.useForm();
    const dispatch = useDispatch();
    const { id } = useParams();
    const masterData = useSelector((state) => state.masters.masters);
    const Option = Select;
    useEffect(() => {
      dispatch(getAllMaster());
      if (isModalOpen && data) {
        form.setFieldsValue({
          LeavePolicyGroupId: data.LeavePolicyGroupId,
          EffectedFrom: data.EffectedFrom ? dayjs(data.EffectedFrom) : null,
          EffectedTo: data.EffectedTo ? dayjs(data.EffectedTo) : null,

        });
      }
    }, [isModalOpen, data, form, dispatch]);
  
    const showModal = () => {
      setIsModalOpen(true);
    };
  
    const handleCancel = () => {
      setIsModalOpen(false);
      form.resetFields();
    };

    const onFinish = async (values) => {
          try {
            setLoading(true);
            const response = await dispatch(EmployeeLeavePolicyGroupHistorySetup({
              ...values,
              EffectedFrom: values.EffectedFrom ? dayjs(values.EffectedFrom).format('YYYY-MM-DD') : null,
              EffectedTo: values.EffectedTo ? dayjs(values.EffectedTo).format('YYYY-MM-DD') : null,
              EmployeeLeavePolicyGroupHistoryId:data.EmployeeLeavePolicyGroupHistoryId,
              EmployeeId: id,
              DataStatus: 1,
            }));
            if (response.payload.message === "success") {
              dispatch(loadSingleStaff(id));
              setIsModalOpen(false);
              form.resetFields();
            }
          } catch (error) {
            // console.error("Error adding employment history:", error);
          } finally {
            setLoading(false);
          }
      };
  
    return (
      <>
        <Button onClick={showModal} className="mr-2">
          Edit
        </Button>
        <Modal
          title="Edit Leave Policy"
          open={isModalOpen}
          onCancel={handleCancel}
          footer={null}
        >
          <Form
            form={form}
            name="editLeavePolicyType"
            layout="vertical"
            onFinish={onFinish}
          >
            <Form.Item
            label="Leave Policy Type"
            name="LeavePolicyGroupId"
            rules={[
              { required: true, message: "Please select an Leave Policy type!" },
            ]}
          >
            <Select 
              placeholder="Select Leave Policy type" 
              allowClear
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {masterData?.LeavePolicyGroupDetails?.map((type) => (
                <Option
                  key={type.LeavePolicyGroupId}
                  value={type.LeavePolicyGroupId}
                >
                  {type.LeavePolicyGroupName}
                </Option>
              ))}
            </Select>
          </Form.Item>
            <Form.Item
              label="Effective From"
              name="EffectedFrom"
              rules={[{ required: true, message: "Please enter the effective date!" }]}
            >
              <DatePicker />
            </Form.Item>
            <Form.Item>
              <Form.Item
            label="Effective To"
            name="EffectedTo"
           
          >
            <DatePicker />
          </Form.Item>
              <Button type="primary" htmlType="submit">
                Update
              </Button>
            </Form.Item>
          </Form>
        </Modal>
      </>
    );
  };
  
  export default LeavePolicyGroupEditSinglePopup